import clsxm from '@/lib/clsxm';

interface FilterProps {
  className?: string;
  children: React.ReactNode;
}

export default function Filter({ className, children }: FilterProps) {
  return (
    <nav className={clsxm(className, 'py-4 text-sm font-medium')}>
      <ul className='flex flex-wrap'>{children}</ul>
    </nav>
  );
}
